import { ILink } from 'generated/contentful';
import { Link } from 'models/contentful/link/types';

export const generateLocalizedUrl = (
  url: string | undefined,
  store: Store,
  language: Language
): string => {
  if (typeof url !== 'string') {
    return '';
  }

  if (url.startsWith('mailto:')) {
    return url;
  }

  if (/^https?:\/\/(.)+$/i.test(url)) {
    return url;
  }

  if (/^[a-z0-9-]+(\/[a-z0-9-]+)*/i.test(url)) {
    return `/${store}/${language}/${url}`;
  }

  if (url === '/') {
    return `/${store}/${language}`;
  }

  if (/^\/[a-z0-9-]+(\/[a-z0-9-]+)*/i.test(url)) {
    return `/${store}/${language}${url}`;
  }

  return url;
};

export default function toLink(
  content: ILink,
  store: Store,
  language: Language
): Link {
  return {
    title: content.fields.title,
    link: generateLocalizedUrl(content.fields.link, store, language),
  };
}
